export const AMPLIFY_CONFIG = {
  Auth: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
  },
  aws_appsync_region: process.env.REACT_APP_REGION,
};
